// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/place_types/natural_features.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/place_types/natural_features.proto.
 */
export const file_proto_model_core_place_types_natural_features = /*@__PURE__*/
  fileDesc("CjNwcm90by9tb2RlbC9jb3JlL3BsYWNlX3R5cGVzL25hdHVyYWxfZmVhdHVyZXMucHJvdG8SBmNhcm1lbipuChhOYXR1cmFsRmVhdHVyZXNQbGFjZVR5cGUSKwonTkFUVVJBTF9GRUFUVVJFU19QTEFDRV9UWVBFX1VOU1BFQ0lGSUVEEAASJQohTkFUVVJBTF9GRUFUVVJFU19QTEFDRV9UWVBFX0JFQUNIEAFCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw");

/**
 * Describes the enum carmen.NaturalFeaturesPlaceType.
 */
export const NaturalFeaturesPlaceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_place_types_natural_features, 0);

/**
 * Natural feature place types
 *
 * @generated from enum carmen.NaturalFeaturesPlaceType
 */
export const NaturalFeaturesPlaceType = /*@__PURE__*/
  tsEnum(NaturalFeaturesPlaceTypeSchema);

